// extracted by mini-css-extract-plugin
export default {"storeLinks":"WhyJopsy_storeLinks__Y-EDx","factsParagraph":"WhyJopsy_factsParagraph__cXz8u","factsLink":"WhyJopsy_factsLink__MeOrQ"};